<template>
  <div>
    <secondHeader />
    <div class="news-main">
      <sidebar />
      <main class="news-content">
        <div class="news-container">
          <!-- Hero Section -->
          <section class="news-hero">
            <div class="news-hero-content">
              <h1 class="news-hero-title">
                <svg class="news-icon" width="32" height="32" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"></path>
                </svg>
                アプデ情報
              </h1>
              <p class="news-hero-description">はいしんツールキットの最新アプデ情報</p>
            </div>
          </section>

          <!-- Updates List Section -->
          <section class="news-grid-section">
            <div class="news-grid">
              <article v-for="(update, index) in allUpdates" :key="update.id" class="news-card" :class="{ featured: index === 0 }">
                <div v-if="update.isNew" class="news-badge">NEW</div>
                <div class="news-card-header">
                  <time class="news-card-date">{{ formatDate(update.date) }}</time>
                  <h2 class="news-card-title">{{ update.title }}</h2>
                </div>
                <div class="news-card-content">
                  <p class="news-card-text" v-html="formatDetailText(update.detailText)"></p>
                  <div v-if="update.links && update.links.length > 0" class="news-card-links">
                    <template v-for="(link, linkIndex) in update.links">
                      <router-link 
                        v-if="link.isInternal" 
                        :key="`${update.id}-${linkIndex}-internal`"
                        :to="link.url" 
                        class="news-card-link"
                      >
                        {{ link.text }}
                      </router-link>
                      <a 
                        v-else 
                        :key="`${update.id}-${linkIndex}-external`"
                        :href="link.url" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        class="news-card-link external"
                      >
                        {{ link.text }}
                        <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                        </svg>
                      </a>
                    </template>
                  </div>
                </div>
              </article>
            </div>
          </section>

          <!-- Ad Section -->
          <section class="news-ad-block">
            <div class="news-ad">
              <InFeedAdsense
                data-ad-layout-key="-fb+5w+4e-db+86"
                data-ad-client="ca-pub-9016794589237931"
                data-ad-slot="4898735474">
              </InFeedAdsense>
            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue";
import sidebar from "../components/sidebar.vue"
import { getAllUpdates, formatUpdateDate } from '@/utils/updateDataManager.js';

export default {
  components: {
    secondHeader,
    sidebar,
  },
  computed: {
    allUpdates() {
      return getAllUpdates();
    }
  },
  methods: {
    formatDate(dateString) {
      return formatUpdateDate(dateString);
    },
    formatDetailText(text) {
      // 改行文字を<br>タグに変換
      return text.replace(/\n/g, '<br>');
    }
  },
  data(){
    return{
      isProduction: process.env.NODE_ENV === "production",
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

/* Global Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Main Layout */
.news-main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  font-family: 'Outfit', system-ui, -apple-system, sans-serif;
}

.news-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.news-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* Hero Section */
.news-hero {
  padding: 80px 0 60px 0;
  text-align: center;
}

.news-hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.news-hero-title {
  font-size: 2rem;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 16px;
  letter-spacing: -0.025em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.news-icon {
  width: 32px;
  height: 32px;
  color: #0f172a;
  flex-shrink: 0;
}

.news-hero-description {
  font-size: 1rem;
  color: #0f172a;
  font-weight: 400;
  line-height: 1.6;
}

/* News Grid Section */
.news-grid-section {
  padding: 0 0 80px 0;
}

.news-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  max-width: 800px;
  margin: 0 auto;
}

/* News Cards */
.news-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
}

.news-card.featured {
  border-color: #e2e8f0;
}

.news-badge {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #0f172a;
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 6px;
  letter-spacing: 0.5px;
}

.news-card-header {
  padding: 24px 32px;
}

.news-card-date {
  display: inline-block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #94a3b8;
  margin-bottom: 12px;
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  letter-spacing: 0.25px;
}

.news-card-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.025em;
  line-height: 1.4;
}

.news-card.featured .news-card-title {
  font-size: 1.75rem;
}

.news-card-content {
  padding: 32px;
}

.news-card-text {
  font-size: 1rem;
  line-height: 1.7;
  color: #4a5568;
  margin-bottom: 24px;
}

.news-card.featured .news-card-text {
  font-size: 1.125rem;
}

.news-card-links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
}

.news-card-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #0f172a;
  color: white;
  text-decoration: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.news-card-link:hover {
  background: #1e293b;
}

.news-card-link.external svg {
  opacity: 0.8;
}

/* Ad Section */
.news-ad-block {
  padding: 40px 0 40px 0;
  background: #f8fafc;
}

.news-ad {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

/* Responsive Design */
@media screen and (max-width: 1024px) {
  .news-container {
    padding: 0 20px;
  }
  
  .news-hero-title {
    font-size: 1.75rem;
  }
  
  .news-icon {
    width: 28px;
    height: 28px;
  }
}

@media screen and (max-width: 768px) {
  .news-main {
    flex-direction: column;
  }
  
  .news-container {
    padding: 0 16px;
  }
  
  .news-hero {
    padding: 60px 0 40px 0;
  }
  
  .news-hero-title {
    font-size: 1.5rem;
    flex-direction: column;
    gap: 12px;
  }
  
  .news-hero-description {
    font-size: 0.95rem;
  }
  
  .news-grid {
    gap: 24px;
  }
  
  .news-card-header {
    padding: 20px 24px;
  }
  
  .news-card-title {
    font-size: 1.3rem;
  }
  
  .news-card.featured .news-card-title {
    font-size: 1.5rem;
  }
  
  .news-card-content {
    padding: 24px;
  }
  
  .news-card-text {
    font-size: 0.95rem;
  }
  
  .news-card.featured .news-card-text {
    font-size: 1rem;
  }
  
  .news-badge {
    top: 16px;
    right: 16px;
    font-size: 0.7rem;
    padding: 4px 8px;
  }
  
  .news-card-links {
    justify-content: flex-start;
    gap: 8px;
  }
  
  .news-card-link {
    padding: 8px 12px;
    font-size: 0.8rem;
  }
}

@media screen and (max-width: 480px) {
  .news-container {
    padding: 0 12px;
  }
  
  .news-hero {
    padding: 40px 0 30px 0;
  }
  
  .news-hero-title {
    font-size: 1.25rem;
  }
  
  .news-icon {
    width: 24px;
    height: 24px;
  }
  
  .news-card-header {
    padding: 16px 20px;
  }
  
  .news-card-title {
    font-size: 1.2rem;
  }
  
  .news-card.featured .news-card-title {
    font-size: 1.3rem;
  }
  
  .news-card-content {
    padding: 20px;
  }
  
  .news-card-links {
    flex-direction: column;
    align-items: stretch;
  }
  
  .news-card-link {
    justify-content: center;
    padding: 10px 16px;
  }
}
</style>